import React, { useEffect, useState } from 'react';
import { ethers } from 'ethers';

import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

import { sequence } from '0xsequence';
import * as UAuthWeb3Modal from '@uauth/web3modal';
import UAuthSPA from '@uauth/js';
// NOTE: here we use a forked package of web3modal, named @0xsequence/web3modal
// Once the web3modal PR https://github.com/Web3Modal/web3modal/pull/402 is merged,
// then you can just import from 'web3modal' directly without any other changes.
import Web3Modal from '@0xsequence/web3modal';

import WalletConnect from '@walletconnect/web3-provider';
import { GlobalStyle, Nav } from './components';
import {
  Home,
  Connect,
  Profile,
  PostDetails,
  CreateProfile,
  Shorts,
  Notifications,
  Settings,
  Search,
} from './pages';
import AppContext from './context/AppContext';

import contract from './utils/contract.json';

import auth from './api/auth';
import { setAuthenticationToken, setRefreshToken } from './api/state';

const CONTRACT_ADDRESS = '0x7992D9C75aBf9d0a7823d18f8c2A6346aAAD5d30';

const uauthOptions = {
  clientID: '63d1a4e9-337a-4525-9e32-10c1a6d75fab',
  redirectUri: 'https://speak-out.netlify.app',
  scope: 'openid wallet',
};

let providerOptions = {
  'custom-uauth': {
    display: UAuthWeb3Modal.display,

    connector: UAuthWeb3Modal?.connector,

    package: UAuthSPA,

    options: uauthOptions,
  },
  walletconnect: {
    package: WalletConnect,
    options: {
      infuraId: 'fdd5eb8e3a004c9c9caa5a91a48b92b6',
      chainId: 80001,
    },
  },
};

if (!window?.ethereum?.isSequence) {
  providerOptions = {
    ...providerOptions,
    sequence: {
      package: sequence,
      options: {
        appName: 'SpeakOut',
        defaultNetwork: '',
        chainId: 80001,
      },
    },
  };
}
const web3Modal = new Web3Modal({
  providerOptions,
  cacheProvider: true,
  theme: `light`,
});
UAuthWeb3Modal?.registerWeb3Modal(web3Modal);
function App() {
  const [theme, setTheme] = useState(JSON.parse(localStorage.getItem('theme')));
  const [sideNav, setSideNav] = useState(false);
  const [minting, setMinting] = useState(false);
  const [publishing, setPublishing] = useState(false);
  const [isMember, setIsMember] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [changingName, setChangingName] = useState(false);
  const [users, setUsers] = useState([]);
  const [accountDetails, setAccountDetails] = useState();
  const [provider, setProvider] = useState();
  const changeTheme = () => {
    setTheme(!theme);
    localStorage.setItem('theme', JSON.stringify(!theme));
  };

  const location = useLocation();
  const [currentAccount, setCurrentAccount] = useState('');

  console.log('LOGGIN HAS LOADED', hasLoaded);
  const checkIfWalletIsConnected = async () => {
    setHasLoaded(false);
    if (web3Modal.cachedProvider) {
      let wallet = await web3Modal.connect();

      const tProvider = new ethers.providers.Web3Provider(wallet);
      setProvider(tProvider);
      // You can list the connected accounts without launching Web3Modal
      const accounts = await tProvider?.listAccounts();
      console.log('CHECKING ACCOUNT ADDRESS', accounts[0]);
      //   console.log('Accounts', accounts);
      if (accounts.length !== 0) {
        const account = accounts[0];
        console.log('Found an authorized account:', account);
        const signer = tProvider.getSigner();
        const connectedContract = new ethers.Contract(
          CONTRACT_ADDRESS,
          contract.abi,
          signer
        );

        setCurrentAccount(account);

        console.log('Going to pop wallet now to pay gas...');
        let chainId = await signer.getChainId();
        if (chainId == 80001) {
        } else {
          alert('CONNECT TO POLYGON MATIC(TESTNET) TO CONTINUE');
        }

        let exist = await auth.getProfile(accounts[0]);
        console.log('HAS A PROFILE', exist?.data?.profiles?.items?.[0]?.id);
        if (exist?.data?.profiles?.items?.[0]?.id) {
          setIsMember(true);
          setAccountDetails(exist.data.profiles.items[0]);
        }

        let refreshtoken = JSON.parse(localStorage.getItem('refreshToken'));
        let authtoken = JSON.parse(localStorage.getItem('authenticationToken'));
        if (authtoken) {
          let verifiedResponse = await auth.verify(authtoken);
          console.log('AUTH TOKEN IS VERIFIED', verifiedResponse.data.verify);
          if (verifiedResponse.data.verify) {
            setIsLoggedIn(true);
          } else {
            console.log('OUTPUT REEFRESH TOKEN', refreshtoken);
            if (refreshtoken) {
              console.log('TRYING TO REFRESH TOKEN');
              try {
                const refreshResponse = await auth.refreshAuth(refreshtoken);
                setAuthenticationToken(
                  refreshResponse.data.refresh.accessToken
                );
                setIsLoggedIn(true);
                console.log('REFRESHING TOKEN', refreshResponse);
              } catch (error) {
                console.log(' ERROR REFRESHING TOKEN SO GENERATE NEW TOKENS');
                const challengeResponse = await auth.generateChallenge(
                  accounts[0]
                );
                console.log('CHALLENGE RESPONSE HERE', challengeResponse);
                const signature = await signer.signMessage(
                  challengeResponse.data.challenge.text
                );
                console.log('SIGNATURE HERE', signature);
                const accessTokens = await auth.authenticate(
                  accounts[0],
                  signature
                );

                console.log('ACCESS TOKENS HERE', accessTokens);
                console.log('CONNECTED', accounts[0]);
                setAuthenticationToken(
                  accessTokens.data.authenticate.accessToken
                );
                setRefreshToken(accessTokens.data.authenticate.refreshToken);
                setIsLoggedIn(true);
              }
            } else {
              console.log('NO REFRESH TOKEN SO GENERATE NEW TOKENS');
              const challengeResponse = await auth.generateChallenge(
                accounts[0]
              );
              console.log('CHALLENGE RESPONSE HERE', challengeResponse);
              const signature = await signer.signMessage(
                challengeResponse.data.challenge.text
              );
              console.log('SIGNATURE HERE', signature);
              const accessTokens = await auth.authenticate(
                accounts[0],
                signature
              );

              console.log('ACCESS TOKENS HERE', accessTokens);
              console.log('CONNECTED', accounts[0]);
              setAuthenticationToken(
                accessTokens.data.authenticate.accessToken
              );
              setRefreshToken(accessTokens.data.authenticate.refreshToken);
              setIsLoggedIn(true);
            }
          }
        } else {
        }

        // Setup listener! This is for the case where a user comes to our site
        // and ALREADY had their wallet connected + authorized.
      } else {
        console.log('No authorized account found');
      }

      // String, hex code of the chainId of the Rinkebey test network
    } else {
      setCurrentAccount();
      setIsMember();
    }
    setHasLoaded(true);
  };

  const connectWallet = async () => {
    if (web3Modal.cachedProvider) {
      web3Modal.clearCachedProvider();
    }
    try {
      const wallet = await web3Modal.connect();

      const tProvider = new ethers.providers.Web3Provider(wallet);

      if (wallet.sequence) {
        tProvider.sequence = wallet.sequence;
      }
      setProvider(tProvider);
      const accounts = await tProvider.listAccounts();
      const signer = tProvider.getSigner();

      const challengeResponse = await auth.generateChallenge(accounts[0]);
      console.log('CHALLENGE RESPONSE HERE', challengeResponse);
      const signature = await signer.signMessage(
        challengeResponse.data.challenge.text
      );
      console.log('SIGNATURE HERE', signature);
      const accessTokens = await auth.authenticate(accounts[0], signature);

      console.log('ACCESS TOKENS HERE', accessTokens);
      console.log('CONNECTED', accounts[0]);
      setAuthenticationToken(accessTokens.data.authenticate.accessToken);
      setRefreshToken(accessTokens.data.authenticate.refreshToken);
      setCurrentAccount(accounts[0]);

      setIsLoggedIn(true);
      setHasLoaded(true);
      checkIfWalletIsConnected();
    } catch (error) {
      console.log('CONNECT ERROR HERE', error);
    }
  };

  const disconnectWeb3Modal = async () => {
    const wallet = await web3Modal.connect();
    const tProvider = new ethers.providers.Web3Provider(wallet);
    if (tProvider && tProvider.sequence) {
      const wallet = tProvider.sequence;
      wallet.disconnect();
    }
    web3Modal.clearCachedProvider();
    setCurrentAccount();
    setIsMember();
    localStorage.setItem('userLevel', JSON.stringify(1));
  };
  // useEffect(() => {
  // if (web3Modal.cachedProvider) {
  //   connectWallet();
  // }
  // }, []);

  useEffect(() => {
    checkIfWalletIsConnected();
    console.log('E dey here oo', web3Modal.cachedProvider);
  }, []);

  return (
    <AppContext.Provider
      value={{
        currentAccount,
        setCurrentAccount,

        minting,
        setMinting,

        connectWallet,
        isMember,
        disconnectWeb3Modal,
        hasLoaded,
        publishing,
        accountDetails,
        isLoggedIn,
        changingName,
        users,
        theme,
        setTheme,
        changeTheme,
        sideNav,
        setSideNav,
      }}
    >
      <div className="App">
        <GlobalStyle theme={theme} />
        <Nav />
        <AnimatePresence exitBeforeEnter>
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<Home />} />
            <Route path="/connect" element={<Connect />} />
            <Route path="/shorts" element={<Shorts />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/search" element={<Search />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/create-profile" element={<CreateProfile />} />
            <Route path="/:id" element={<Profile />} />
            <Route path="/:id/posts/:postId" element={<PostDetails />} />
          </Routes>
        </AnimatePresence>
        {/* <Footer theme={theme} /> */}
      </div>
    </AppContext.Provider>
  );
}

export default App;
